import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c2d1ead"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CategoryTmall" }
const _hoisted_2 = { class: "CategoryTmall-title" }
const _hoisted_3 = { class: "CategoryTmall-list" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "CategoryTmall-list-column-separator"
}

import { t } from '@/plugins/i18n'
import { cTmall } from '@/assets/js/platform/category'
import { useSite2Station } from '@/store'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationCode = useSite2Station()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(_unref(cTmall).title)), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cTmall).row, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "CategoryTmall-list-row",
          key: rowIndex
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.column, (column, columnIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "CategoryTmall-list-column",
              key: columnIndex
            }, [
              _createElementVNode("a", {
                class: "CategoryTmall-list-column-name",
                href: column.url,
                target: "_blank"
              }, _toDisplayString(_unref(stationCode)=== _unref(Site).JA ? column.name_ja : _unref(t)(column.name)), 9, _hoisted_4),
              (columnIndex !== row.column.length-1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})